<mat-toolbar class="dialog-title">
  <span>Cambiar contraseña</span>
  <div *ngIf="sharedService.userSession.estado==1" (click)="cerrar()" class="close-dialog">
    <i class="fas fa-times"></i>
  </div>
</mat-toolbar>

<div mat-dialog-content>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Ingrese contraseña actual<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="claveActual" type="password">
  </mat-form-field>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Ingrese nueva contraseña <span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="clave" type="password" matTooltip="La contraseña debe ser alfanumérica, entre letras mayúsculas , minúsculas , números y caracteres especiales y debe tener mínimo 8 dígitos">
  </mat-form-field>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Repita su nueva contraseña<span style="color: red;">*</span></mat-label>
    <input matInput [(ngModel)]="repetirClave" type="password" matTooltip="La contraseña debe ser alfanumérica, entre letras mayúsculas , minúsculas , números y caracteres especiales y debe tener mínimo 8 dígitos">
  </mat-form-field>
  <div class="dialog-buttons">
    <button [disabled]="validarCampos()" mat-raised-button class="btn_olive" (click)="actualizarClave()">Registrar</button>&nbsp;
    <button *ngIf="sharedService.userSession.estado==1" mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
  </div>
</div>
